/**
 * All writes are proxied through backend Cloud Functions — the frontend never
 * writes to Firestore directly. Requests hit "/api/*", which Firebase Hosting
 * rewrites to the `api` Cloud Function.
 */

export type InquiryType = "stay" | "event" | "contact";

export interface InquiryPayload {
  type: InquiryType;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  /** Reason / subject for contact form. */
  subject?: string;
  message: string;
  /** Optional structured fields for booking inquiries. */
  checkIn?: string;
  checkOut?: string;
  guests?: string;
  eventType?: string;
  eventDate?: string;
  overnightStay?: string;
  budget?: string;
  /** Pathname of the page where the form was submitted (VR-3). */
  page?: string;
}

export interface InquiryResult {
  ok: boolean;
  error?: string;
}

export async function submitInquiry(payload: InquiryPayload): Promise<InquiryResult> {
  try {
    const res = await fetch("/api/inquiry", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const data = (await res.json().catch(() => ({}))) as { error?: string };
      return { ok: false, error: data.error ?? `Request failed (${res.status})` };
    }
    return { ok: true };
  } catch {
    return { ok: false, error: "Network error — please try again." };
  }
}
